// extracted by mini-css-extract-plugin
export default {"root":"pure-backdrop_root__AP9KR"};